import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/posts";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="scroll-mt-24 border-y border-background-200 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <SectionHeading
          align="center"
          eyebrow="FAQ"
          title="常见问题"
          desc="关于投稿、评论和内容规则，你可能想先弄清楚这些。"
        />

        <div className="mx-auto mt-10 max-w-3xl divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 cursor-pointer md:px-7"
                  >
                    <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">{item.q}</span>
                    <i
                      className={`shrink-0 text-xl text-primary-600 transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                      aria-hidden="true"
                    />
                  </button>
                </h3>
                {isOpen && (
                  <div className="px-5 pb-6 md:px-7">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}